import styled from 'styled-components';
import AdSenseUnit from '../../elements/AdSenseUnit';
import BodyText from '../../elements/BodyText';
import Title from '../../elements/Title';
import Image from '../../elements/Image';
var Grid = styled.div.withConfig({
  displayName: "GhostArticlestyles__Grid",
  componentId: "pantheon__sc-1nd9mps-0"
})(["display:flex;"]);
export var ArticleHero = styled(Grid).withConfig({
  displayName: "GhostArticlestyles__ArticleHero",
  componentId: "pantheon__sc-1nd9mps-1"
})(["padding:1rem 0;margin-bottom:1rem;@media (max-width:992px){padding:0;}@media (max-width:768px){flex-direction:column;align-items:center;}"]);
export var HeroContent = styled.div.withConfig({
  displayName: "GhostArticlestyles__HeroContent",
  componentId: "pantheon__sc-1nd9mps-2"
})(["display:flex;flex-direction:row;width:78%;margin:0 auto;@media (max-width:992px){width:90%;}@media (max-width:768px){justify-content:center;flex-direction:column;}"]);
export var ArticleImage = styled(Image).withConfig({
  displayName: "GhostArticlestyles__ArticleImage",
  componentId: "pantheon__sc-1nd9mps-3"
})(["height:350px;width:600px;object-fit:cover;background-repeat:no-repeat;background-size:cover;background-position:center center;display:block;@media (max-width:992px){height:275px;width:475px;}@media (max-width:768px){height:300px;width:100%;justify-content:center;}"]);
export var TitleAndReadingTime = styled(Grid).withConfig({
  displayName: "GhostArticlestyles__TitleAndReadingTime",
  componentId: "pantheon__sc-1nd9mps-4"
})(["flex-direction:column;@media (max-width:768px){margin-bottom:0.5rem;}"]);
export var ArticleTitle = styled(Title).withConfig({
  displayName: "GhostArticlestyles__ArticleTitle",
  componentId: "pantheon__sc-1nd9mps-5"
})(["font-size:30px;margin:0 0 1rem 0;color:", ";font-family:", ";@media (max-width:768px){margin:1rem 0 0.5rem 0;}", ";"], function (props) {
  var _props$colors;

  return ((_props$colors = props.colors) == null ? void 0 : _props$colors.title) || "black";
}, function (props) {
  return props.fonts.title;
}, function (props) {
  var _props$theme;

  return (_props$theme = props.theme) == null ? void 0 : _props$theme.ghostTitle;
});
export var ReadingTime = styled.div.withConfig({
  displayName: "GhostArticlestyles__ReadingTime",
  componentId: "pantheon__sc-1nd9mps-6"
})(["margin-top:0.5rem;color:", ";font-family:", ";", ";"], function (props) {
  var _props$colors2;

  return ((_props$colors2 = props.colors) == null ? void 0 : _props$colors2.readtime) || "black";
}, function (props) {
  return props.fonts.body;
}, function (props) {
  var _props$theme2;

  return (_props$theme2 = props.theme) == null ? void 0 : _props$theme2.ghostReadTime;
});
export var ArticleInfo = styled(Grid).withConfig({
  displayName: "GhostArticlestyles__ArticleInfo",
  componentId: "pantheon__sc-1nd9mps-7"
})(["flex-direction:column;justify-content:space-between;text-overflow:ellipsis;margin-left:30px;@media (max-width:768px){padding-bottom:25px;margin-left:0;margin-right:15px;justify-content:center;}"]);
export var BackTo = styled(BodyText).withConfig({
  displayName: "GhostArticlestyles__BackTo",
  componentId: "pantheon__sc-1nd9mps-8"
})(["position:relative;padding:1rem 0 0 7rem;font-size:18px;font-weight:700;font-family:", ";color:", ";text-decoration:none;cursor:pointer;@media (max-width:992px){padding-left:1.5rem;}", ";"], function (props) {
  return props.fonts.backto;
}, function (props) {
  var _props$colors3;

  return ((_props$colors3 = props.colors) == null ? void 0 : _props$colors3.backto) || "black";
}, function (props) {
  var _props$theme3;

  return (_props$theme3 = props.theme) == null ? void 0 : _props$theme3.ghostBackTo;
});
export var DefaultStyledAdSenseUnit = styled(AdSenseUnit).withConfig({
  displayName: "GhostArticlestyles__DefaultStyledAdSenseUnit",
  componentId: "pantheon__sc-1nd9mps-9"
})(["width:100%;display:block;max-width:970px;height:90px;margin:1.5rem auto;@media only screen and (max-width:768px){max-width:728px;height:90px;margin:1.5rem auto;}@media only screen and (max-width:576px){max-width:320px;margin:1rem auto;height:100px;}"]);